import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import React, { useEffect, useState } from "react";
import BottomNav from "../../components/bottomNav";
import { useHistory } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";

//TODO: To refactor
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");
const useProfileState = createPersistedState("profile");

function SubmitStep({ data, fromRoute, rawFrom }) {
  const { previousStep, nextStep } = useWizard();
  const history = useHistory();
  const { t } = useTranslation();

  const getUrl = () => `/api/v1/users/profile/${pid}/healthinfo`;
  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [profile, setProfile] = useProfileState();
  const [submitSuccess, setSubmitSuccess] = useState(false);

  useEffect(() => {
    submitHealthInfo();
  }, [pid, token]);

  const extractFormattedResponse = () => {
    console.log(data);
    let _response = [];
    Object.keys(data).forEach((key) => {
      if (data[key] && data[key]["_state"] !== null) {
        const singleResponse = data[key]["formatted_response"];
        if (singleResponse?.constructor === Array) {
          singleResponse.forEach((subResponse) => {
            _response.push(subResponse);
          });
        } else {
          _response.push(singleResponse);
        }
      }
    });
    return _response;
  };

  const submitHealthInfo = () => {
    fetch(getUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(extractFormattedResponse()),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          console.log(responseData);
          setProfile((profileState) => ({
            ...profileState,
            healthInfoPopup: false,
            healthInfoFilled: true,
          }));

          if (fromRoute) {
            history.push(`/diet-info/start?from=${rawFrom}`);
            return;
          }
          history.push("/my-health");
        }
      });
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={t("hi.title")}
        hideLibrary={true}
      />
      <div className="body_content ">
        <div className="inner_body">
          <div className="successful_msg mt-5 pt-5 h-100 align-items-center">
            <h3 className="subtitle mb-4 text-center">
              {submitSuccess ? t("hi.submitText1") : t("hi.submitText2")}
            </h3>
            <br />
          </div>
          <BottomNav />
        </div>
      </div>
    </>
  );
}

export default SubmitStep;
